import script from "./ClubEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubEdit.vue?vue&type=script&setup=true&lang=js"

import "./ClubEdit.vue?vue&type=style&index=0&id=2ee4bd24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ee4bd24"]])

export default __exports__